
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Provider } from "./Provider";
import Html from "./Html";
import { ftmTemporaryToken, temporaryLogin } from "./service";
import { setFtm } from "../storage/ftm";
import PageLocading from "../common/PageLoading";

const Registration = () => {
    const { key } = useParams();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const temporaryAuth = async() => {
            try{
                setLoading(true);
                const temporaryTokenResponse = await ftmTemporaryToken(key);
                if (temporaryTokenResponse.status === "Success") {
                    const temporaryLoginResponse = await temporaryLogin(temporaryTokenResponse?.temporary_token);

                    if (temporaryLoginResponse.status === "Success") {
                        setFtm({
                            ftm_id: temporaryLoginResponse?.ftm_id,
                            temporary_token: temporaryLoginResponse?.temporary_token,
                            token: temporaryLoginResponse?.token,
                            refreshToken: temporaryLoginResponse?.refreshToken
                        });

                        setLoading(false);
                    }
                }
            }catch{
                console.error("Registration failed:");
            }
        };

        if(key){
            temporaryAuth();
        }
    }, [key]);

    if(loading) {
        return <PageLocading />;
    }

    return (
        <Provider>
            <Html/>
        </Provider>
    );
}

export default Registration;